/* The constants below will be replaced at compile time */
/*
export default {
  apiKey: process.env.REACT_APP__FIREBASE_API_KEY || 'AIzaSyALQ90sT8yAmurZ9wCMLgy2vk7KeslxrQA',
  authDomain: process.env.REACT_APP__FIREBASE_AUTH_DOMAIN || 'mentalist-dev-62ec5.firebaseapp.com',
  databaseURL: process.env.REACT_APP__FIREBASE_DATABASE_URL || 'https://mentalist-dev-62ec5.firebaseio.com',
  storageBucket: process.env.REACT_APP__FIREBASE_STORAGE_BUCKET || 'mentalist-dev-62ec5.appspot.com',
  messagingSenderId: process.env.REACT_APP__FIREBASE_MESSAGING_SENDER_ID || '373299020204',
};
*/

/* The constants below will be replaced at compile time */
export default {
  apiKey: process.env.REACT_APP__FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP__FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP__FIREBASE_DATABASE_URL,
  storageBucket: process.env.REACT_APP__FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP__FIREBASE_MESSAGING_SENDER_ID,
};



// WEBPACK FOOTER //
// ./src/config/firebase.js